<template>
  <div class="px-1 mb-2">
    <div :class="clazz">
      <div class="card-header" v-if="title">
        <h3>{{title}}</h3>
      </div>
      <div class="card-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    context: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    clazz() {
      return `card text-white bg-${this.context}`;
    }
  }
};
</script>

<style>
</style>
